<template>
    <div class="dj-container">
        <!--创建-->
        <div class="head-container">
            <div class="left-head-container" >
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="right-head-container">{{ form.title }}</div>
            <div class="left-head-container">
            </div>
        </div>
        <div class="dj-time">发布时间：{{ timestampToTime(form.releaseTime) }}</div>
        <div class="dj-content" v-html="form.appContent">
        </div>
    </div>
</template>

<script>
import {infoDangj} from "@/api/admin/dangj"
import {timestampToTime} from "@/utils/date";

export default {
    name: "dangjInfo",
    components: {
    },
    props:{
        dangjId:{
            type: String,
            default:null
        },
    },
    watch:{
        dangjId(newValue,oldValue){
            this.form = {}
            this.getDangjInfo()
        },
    },
    data() {
        return {
            form:{},  //数据
            timestampToTime,
        };
    },
    created() {},
    mounted() {
        this.getDangjInfo()
    },
    unmounted() {},
    computed: {},
    methods:{
        getDangjInfo(){
            infoDangj({ dangjId: this.dangjId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                    var text = JSON.parse(JSON.stringify(this.form.content))
                    text = text.replace(/<video/gi,"<video style='width:96% !important;height:30% !important;background:#333 !important;'")
                    text = text.replace(/<img/gi,"<img style='width: 96% !important;height:auto !important;vertical-align: middle !important;max-height:96%;margin:0 auto !important;'")
                    text = text.replace(/<p style="/gi,'<p style="text-indent: unset !important;')
                    this.form.appContent = text
                    this.$emit('change-mode',"detailSub");
                }else {
                    this.$message.error("操作失败")
                }
            })
        }
    },
};
</script>
<style scoped>
.dj-container{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.dj-title{
    height: 45px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #DDD;
}
.dj-time{
    height: 40px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 15px;
    color: #666666;
}
.dj-content{
    width: 96%;
    margin: auto;
    overflow-x: hidden;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
</style>